interface SidebarMenuOptionalConfig {
  parentRoute?: string,
  fullPageWidth?: boolean,
  style?: MenuItemStyle
}

export class SidebarMenuItem {
  icon = '';

  text = '';

  route = '';

  style: MenuItemStyle = 'default';

  parentRoute = '';

  // width control for the child content page component
  fullPageWidth = false;

  constructor(
    icon: string,
    text: string,
    route: string,
    optionalConfig?: SidebarMenuOptionalConfig,
  ) {
    this.icon = icon;
    this.text = text;
    this.route = route;
    if (optionalConfig) {
      this.parentRoute = optionalConfig.parentRoute ?? this.parentRoute;
      this.style = optionalConfig.style ?? this.style;
      this.fullPageWidth = optionalConfig.fullPageWidth ?? this.fullPageWidth;
    }
  }
}

export type SideBarMenuProps = {
  clickHandler?: (menu: SidebarMenuItem) => void;
  menu: SidebarMenuItem[];
  headerTitle?: string;
  icon?: string;
  onSelectedMenuItemIndex: (index: number) => void;
  onClickLogout?: () => void;
  // privacyPolicyPath?:string
};

export type SideBarMenuState = {
  selectedIndex: number;
}

type MenuItemStyle = 'default' | 'premium' | 'notification';
